﻿; (function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		define(['jquery', 'pubsub'], factory);
	} else {
		root.reGeneralUtilities = factory(root.jQuery, root.PubSub);
	}
}(this, function ($, pubsub) {
		'use strict';

		var actions, settings;
		
		actions = {};
		settings = {};

		settings.accordionLinkSelector = '.js-accordion-link';
		settings.accordionLinkSelectedClass = 'js-accordion-link-selected';
		settings.accordionSectionSelector = '.js-accordion-section';
		settings.accordionSectionVisibleClass = 'js-accordion-section-visible';


		actions.bind = function (e, data) {
			$(data.selector).on('click.accordionControl', settings.accordionLinkSelector, function (e) {
				var $this, id;

				e.preventDefault();
				$this = $(e.target);
				id = $this.attr('href');

				// Check if the section is already open
				var isOpen = $(id).hasClass(settings.accordionSectionVisibleClass);

				if (!isOpen) {
					actions.expand(null, $this);
					return;
				}

				// close the selected section
				$(id).removeClass(settings.accordionSectionVisibleClass);
				$this.removeClass(settings.accordionLinkSelectedClass);

			});
		};

		actions.unbind = function (e, data) {
			var $target;

			$target = $(data.selector);

			$target.off('click.accordionControl');
			$target.find('.' + settings.accordionLinkSelectedClass).removeClass(settings.accordionLinkSelectedClass);
			$target.find('.' + settings.accordionSectionVisibleClass).removeClass(settings.accordionSectionVisibleClass);
		};

		actions.expand = function (e, data) {
			var $target, notAllowToClose, accordionLinks, accordionSections;
			
			if (data.selector) {
				$target = $(data.selector);
				accordionLinks = $target.find(settings.accordionLinkSelector);
				accordionSections = $target.find(settings.accordionSectionSelector);
			} else {
				accordionLinks = $(data);
				accordionSections = $($(data).attr('href'));
			}

			// Remove the accordions title
			accordionLinks.each(function () {
				var $accordionLink = $(this);
				notAllowToClose = $accordionLink.data('not-close') === true;
				if (notAllowToClose) {
					$accordionLink.remove();
				}
			});

			accordionLinks.addClass(settings.accordionLinkSelectedClass);
			accordionSections.addClass(settings.accordionSectionVisibleClass);
		};

		pubsub.subscribe('accordionControl.bind', actions.bind);
		pubsub.subscribe('accordionControl.unbind', actions.unbind);
		pubsub.subscribe('accordionControl.expand', actions.expand);

		return true;
	}));
